import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import styled from 'styled-components'
import firebase from 'firebase'
import { signOut } from '../../store/actions/authActions'
import MapList from '../maps/MapList'

const FormContainer = styled.div`
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  padding: 0.8em;
  background: #0063c0;
  color: #0063c0;
  margin-left: 230px;
  @media only screen and (max-width: 700px) {
    margin-left: 0;
  }
`
const FormBox = styled.form`
  position: relative;
  margin: 40px auto;
  height: 200px;
  width: 350px;
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11),
              0 5px 15px 0 rgba(0,0,0,0.08);
  text-align: left;
  padding: 15px 0;
`
const SpaceForText = styled.div`
margin: 0 40px;
`
const NaviList = styled.ul`
  padding: 0;
  text-align: center;
  li {
    list-style: none;
    padding: 10px 0;
  }
  li:hover {
    color: #0063c0;
    cursor: pointer;
  }
`

class Profile extends Component {
  handleClick = () => {
    this.props.signOut();
    this.props.history.push('/');
  }
  render() {
    const { maps } = this.props;
    return (
      <FormContainer>
        <FormBox>
        <SpaceForText>
          <h2>Hello {firebase.auth().currentUser.displayName}</h2>
          <NaviList>
              <button onClick={this.handleClick}>Log Out</button>
          </NaviList>
          </SpaceForText>
          </FormBox>
          <h2>Your Maps</h2>
          <MapList maps={maps} authorUid={firebase.auth().currentUser.uid} />
      </FormContainer>
      
    )
  }
}

const mapStateToProps = (state) => {
  return {
    maps: state.firestore.ordered.maps
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
      signOut: () => dispatch(signOut())
    }
  }
  
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect([
      { collection: 'maps', orderBy: ['createdAt', 'desc']}
    ])
  )(Profile)



// WEBPACK FOOTER //
// ./src/components/profile/Profile.js